$(document).ready(function () {
    let accoFunc = function (clickedItem) {
        let $this = clickedItem,  //$(this)
            accoItem = $this.closest('.acco__item'),
            accoContent = accoItem.find('.acco__content'), // блок с текстом
            reqHeight = accoContent.outerHeight(true),
            accoContentWrap = accoItem.find('.acco__contentWrap'),
            otherAccoItems = accoItem.siblings(),
            otherAccoItemsContentWrap = otherAccoItems.find('.acco__contentWrap');

        if (accoItem.hasClass('active')) {
            accoContentWrap.css('overflow', 'hidden');/**/
            accoContentWrap.css('height', 0);
            accoItem.removeClass('active');
        } else {
            accoItem.addClass('active');
            accoContentWrap.css('height', reqHeight);

            setTimeout(
                /*подождать пока откроется во всю высоту (отработает transition css)*/
                function() {
                    accoContentWrap.css('overflow', 'visible');/*чтобы всплывашки внутри было видно целиком*/
                }, 500
            );

            otherAccoItems.removeClass('active');
            otherAccoItemsContentWrap.css('overflow', 'hidden');/**/
            otherAccoItemsContentWrap.css('height', 0);
        }
    };

    $('.accoDescriptions.acco .acco__trigger').on('click', function (e) {
        e.preventDefault();

        accoFunc($(this));
    });

    $('.offer-list-item.one-offer').trigger('click');
});
